export default __webpack_public_path__ + "locales/vi/DeleteDialog.json?hash=1226d7e1b493b4078d3011445fe5740a";